import { render, staticRenderFns } from "./questionChoiceMultiple.vue?vue&type=template&id=548d445e&scoped=true"
import script from "./questionChoiceMultiple.vue?vue&type=script&lang=js"
export * from "./questionChoiceMultiple.vue?vue&type=script&lang=js"
import style0 from "./questionChoiceMultiple.vue?vue&type=style&index=0&id=548d445e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548d445e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('548d445e')) {
      api.createRecord('548d445e', component.options)
    } else {
      api.reload('548d445e', component.options)
    }
    module.hot.accept("./questionChoiceMultiple.vue?vue&type=template&id=548d445e&scoped=true", function () {
      api.rerender('548d445e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/questionType/questionChoiceMultiple.vue"
export default component.exports